import React, { FC, ReactNode } from 'react';
import { Fade, Slide } from '@mui/material';
import { KYC_VERIFICATION_CONSTANTS } from '../constants';
import { KycAnimationWrapper } from '../styled';

interface KycAnimationWrapperProps {
  isVisible: boolean;
  children: ReactNode;
}

export const KycAnimationWrapperComponent: FC<KycAnimationWrapperProps> = ({
  isVisible,
  children,
}) => {
  return (
    <Slide
      direction="down"
      in={isVisible}
      timeout={KYC_VERIFICATION_CONSTANTS.ANIMATION.SLIDE_TIMEOUT}
      unmountOnExit
    >
      <Fade
        in={isVisible}
        timeout={KYC_VERIFICATION_CONSTANTS.ANIMATION.FADE_TIMEOUT}
      >
        <KycAnimationWrapper>{children}</KycAnimationWrapper>
      </Fade>
    </Slide>
  );
};
